import {
  buildReviewableCandidateShell,
  buildReviewableOrigin,
  REVIEWABLE_ORIGIN_COLLECTIONS,
  REVIEWABLE_ORIGIN_TYPES,
} from '../features/reviewableItems/reviewableItemFlow';
import {
  getTrackerTypeLabel,
  normalizeTrackerType,
} from '../features/tracking/trackerTypes';

const normalizeText = (value = '') => String(value || '').trim();

export const TRACKER_EVIDENCE_REVIEW_DOMAIN = 'tracker_evidence';
export const TRACKER_EVIDENCE_ALLOWED_ACTIONS = ['track', 'ignore'];

export const buildTrackerEvidenceCandidate = ({
  origin = {},
  extractedItem = {},
  trackerType = '',
  confidence = '',
  suggestedAction = 'track',
} = {}) => {
  const normalizedTrackerType = normalizeTrackerType(
    trackerType
    || extractedItem.trackerType
    || extractedItem.type
  );
  const trackerTypeLabel = getTrackerTypeLabel(normalizedTrackerType);
  const summary = normalizeText(
    extractedItem.summary
    || extractedItem.description
    || extractedItem.title
    || extractedItem.label
    || extractedItem.sourceText
  );
  const sourceText = normalizeText(extractedItem.sourceText || origin.sourceText || summary);
  const savedOrigin = buildReviewableOrigin({
    id: origin.id,
    type: origin.type || REVIEWABLE_ORIGIN_TYPES.TIMELINE_ENTRY,
    collection: origin.collection || REVIEWABLE_ORIGIN_COLLECTIONS.DAILY_LOGS,
    childId: origin.childId,
    sourceText,
    sourceSaved: origin.sourceSaved !== false,
    metadata: origin.metadata || {},
  });

  return {
    ...buildReviewableCandidateShell({
      origin: savedOrigin,
      domain: TRACKER_EVIDENCE_REVIEW_DOMAIN,
      label: summary || trackerTypeLabel || 'Tracker evidence',
      canonicalLabel: `${normalizedTrackerType}:${summary}`,
      sourceText,
      allowedActions: TRACKER_EVIDENCE_ALLOWED_ACTIONS,
      suggestedAction,
      confidence,
      payload: {
        trackerType: normalizedTrackerType,
        trackerTypeLabel,
        summary,
        value: extractedItem.value ?? null,
        unit: normalizeText(extractedItem.unit),
        occurredAt: extractedItem.occurredAt || extractedItem.time || null,
        entryDayKey: normalizeText(extractedItem.entryDayKey || origin.entryDayKey),
        suggestedTrackerTitle: normalizeText(
          extractedItem.suggestedTrackerTitle
          || extractedItem.trackerTitle
          || extractedItem.title
          || summary
        ),
      },
    }),
    extracted: {
      trackerType: normalizedTrackerType,
      summary,
      sourceText,
    },
  };
};
